module.exports = __webpack_public_path__ + "static/img/gq3.63d12314.png";